import { render, staticRenderFns } from "./Airplane-travel.vue?vue&type=template&id=e2543cfe&"
import script from "./Airplane-travel.vue?vue&type=script&lang=js&"
export * from "./Airplane-travel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports